import GraphNav from './GraphNav';
import { POPULARITY_SORT_OPTIONS } from 'utils/metrics';
import usePopularity from 'utils/hooks/usePopularity';

const defaultSortOptions = [
    POPULARITY_SORT_OPTIONS.popularity_index_avg_12_month,
    POPULARITY_SORT_OPTIONS.increase_YoY,
    POPULARITY_SORT_OPTIONS.YoY,
    POPULARITY_SORT_OPTIONS.increase_QoQ,
    POPULARITY_SORT_OPTIONS.QoQ,
    POPULARITY_SORT_OPTIONS.increase_MoM,
    POPULARITY_SORT_OPTIONS.MoM,
];

function PopularityGraphNav({ ids, categoryId, countryId, ...restProps }) {
    const popularityQuery = usePopularity({
        enabled: !!(ids && countryId),
        categories: ids || null,
        countries: countryId ? [countryId] : null,
        paginateBy: 'categories',
    });

    return (
        <GraphNav
            {...restProps}
            data={popularityQuery.data}
            isLoading={popularityQuery.isLoading || !countryId || !ids?.length}
            categoryId={categoryId}
            sortOptions={defaultSortOptions}
            primaryMetric={defaultSortOptions[0]}
            defaultSecondaryMetric={POPULARITY_SORT_OPTIONS.YoY}
        />
    );
}

export default PopularityGraphNav;
